<template>
  <div>
    <div class="drayage-buttons">
      <!-- Tabla de Total Quote -->
      <div class="list-detail">
        <table class="detail-table">
          <tbody>
            <tr v-for="(item, index) in formattedQuote" :key="index">
              <td> + {{ item.description }}</td>
            </tr>
          </tbody>
          <tbody>
            <tr v-for="(item, index) in formattedQuotePrice" :key="index" :class="'total-price-item'">
              <td>{{ item.description }}</td>
              <td>{{  formatCurrency(item.total)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="drayage-buttons__container" v-if="canDispatch || canDispatch === null">
        <div id="drayage-book-wrapper">
          <!-- Botón BOOK -->
          <button
            class="quote-button quote-button--blue"
            :class="{ 'disabled-button': loadingInsurance || disableEditQuoteButton }"
            :disabled="loadingInsurance || disableEditQuoteButton"
            @click="handleSelectedCarrier(false)"
          >
            <div class="container-info" v-if="!loadingInsurance">
              <div class="container-info__label">
                <p>BOOK</p>
              </div>
              <div class="container-info__prices">
                <span>USD ${{ price }}</span>
              </div>
            </div>
            <b-spinner small v-if="loadingInsurance" variant="light" />
          </button>
          <b-popover target="drayage-book-wrapper" triggers="hover" placement="top">
            <div v-if="disableEditQuoteButton">
              {{ $t("carriers.editDrayageQuoteDisabledMessage") }}
            </div>
          </b-popover>
        </div>
        <div id="drayage-book-insurance-wrapper">
          <button
            class="quote-button quote-button--green"
            :class="{ 'disabled-button': loadingInsurance || disableEditQuoteButton }"
            :disabled="loadingInsurance || disableEditQuoteButton"
            @click="handleSelectedCarrier(true)"
          >
            <div class="container-info" v-if="!loadingInsurance">
              <div class="container-info__label">
                <p>BOOK WITH INSURANCE</p>
              </div>
              <div class="container-info__prices">
                <span>USD ${{ priceWithInsurance }}</span>
              </div>
            </div>
            <b-spinner small v-if="loadingInsurance" variant="light" />
          </button>
          <b-popover target="drayage-book-insurance-wrapper" triggers="hover" placement="top">
            <div v-if="disableEditQuoteButton">
              {{ $t("carriers.editDrayageQuoteDisabledMessage") }}
            </div>
            <div v-else-if="!cargoInsurance">
              {{ $t("carriers.drayageDefaultInsuranceMessage") }}
            </div>
          </b-popover>
        </div>
      </div>
      <div class="section-container-text" v-if="canDispatch === false">
        <div class="carrier-price">
          <span>
            <b>PRICE:</b>
            USD {{ price }}</span
          >
        </div>
        <div class="carrier-insurance-price">
          <span>
            <b>PRICE WITH INSURANCE:</b>
            USD {{ priceWithInsurance }}
          </span>
        </div>
      </div>
    </div>
    <div class="disclaimer-info">
      <span  v-if="carrierInfo && carrierInfo.chsSubtotal === 0" class="disclaimer-info__text">
       <i><img
            class="icons-tools"
            src="@/assets/scss/icons/info-circle-svgrepo-com.svg"
            alt="messageNonChasis1"
        /></i>
        {{$t('myLoads.messageNonChasis1')}} {{carrierInfo ? carrierInfo.chsMinRentalDays : ''}} {{nonChasisMessage}}
      </span>
      <span  class="disclaimer-info__text">
       <i><img
            class="icons-tools"
            src="@/assets/scss/icons/info-circle-svgrepo-com.svg"
            alt="messageRatesDrayage"
        /></i>
        {{$t('myLoads.messageRatesDrayage')}}
      </span>
      <span  class="disclaimer-info__text" v-if="carrierInfo.miles > 150">
       <i><img
            class="icons-tools"
            src="@/assets/scss/icons/info-circle-svgrepo-com.svg"
            alt="messageRatesDrayage"
        /></i>
        {{$t('myLoads.messageMileDrayage')}}
      </span>
    </div>
      <!-- Modal para aceptación de cotización -->
      <b-modal
        v-model="showModal"
        hide-header
        hide-footer
        size="lg"
        no-close-on-backdrop
        centered
      >
        <QuoteAcceptanceModal
          :insurance="insurance"
          :aditionalInsurance="aditionalInsurance"
          :carrier="carrierInfo"
          :lineItems="lineItems"
          @closeModal="closeModal"
          @optionSelected="emitOptionSelected"
        />
      </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import QuoteAcceptanceModal from "../../QuoteAcceptanceModal.vue";
import { accessorialsQuoteDrayage, priceQuoteDrayage } from "../../../../../../../utils/DrayageDetails";

export default {
  name: "DrayageButtonsAcceptance",
  components: {
    QuoteAcceptanceModal
  },
  props: {
    priceWithInsurance: {
      type: Number,
    },
    aditionalInsurance: {
      type: Number,
      default: 35
    },
    cargoInsurance: {
      type: Number,
      default: 0
    },
    loadingInsurance: {
      type: Boolean,
      default: false,
    },
    lineItems: {
      type: Array,
      default: () => [],
    },
    row: {
      type: Object,
      default: () => {},
    },
    chosenLoadById: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showModal: false,
      insurance: false,
      accessorialsQuoteDrayage,
      canDispatch: null,
    };
  },
  created() {
    this.canDispatch = this.$store.getters["login/getTokenInfo"].can_dispatch;
  },
  computed: {
    ...mapGetters({
      carrierInfo: "drayage/getCarrierInfo",
    }),
    price() {
      return this.carrierInfo?.price?.toFixed(2) || "0.00";
    },
    disableEditQuoteButton() {
      return !this.chosenLoadById?.origin_portal_quote;
    },
    nonChasisMessage() {
      const isBranded = this.$store.getters["login/getTokenInfo"].is_branded;
      return isBranded ? this.$t("myLoads.messageNonChasisbranded") : this.$t("myLoads.messageNonChasis2");
    },
    formattedQuote() {
      const carrierData = this.carrierInfo;
      if (!carrierData) return [];

      return Object.entries(accessorialsQuoteDrayage)
        .filter(([key]) => Boolean(carrierData[key]))
        .map(([key, label]) => {
          let description = label;

          if (key === 'totalChsRental' && carrierData.totalChsRental) {
            description = `${label} (${this.getRentalDays(carrierData.chsMinRentalDays)} days)`;
          }

          return {
            description,
            total: carrierData[key]
          };
        });
    },
    formattedQuotePrice() {
      const carrierData = this.carrierInfo;
      if (!carrierData) return [];

      return Object.entries(priceQuoteDrayage)
        .filter(([key]) => Boolean(carrierData[key]))
        .map(([key, label]) => this.formatQuoteItem(key, label, carrierData[key]));
    }
  },
  methods: {
    handleSelectedCarrier(withInsurance) {
      this.insurance = withInsurance;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    emitOptionSelected(params) {
      this.$emit("optionSelected", {
        ...params,
        changeView: true
      });
      this.closeModal();
    },
    formatCurrency(value) {
      return `$${value.toFixed(2) || 0}`;
    },
    formatQuoteItem(key, label, value) {
      return {
        description: label,
        total: value
      };
    },
    getQuoteLabels() {
      return accessorialsQuoteDrayage;
    },
    getRentalDays(value) {
      const specialVendors = ["CLEAR TRANSPORT LLC"];
      const isSpecialVendor = specialVendors.includes(this.carrierInfo.vendor.name);
      const isRentalFree = this.carrierInfo.totalChsRental === 0;

      if (value !== 2) {
        if (isSpecialVendor && isRentalFree) {
          return value;
        }
        return 2;
      }
      return value;
    }
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/components/Modal.scss";
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_mixin' as *;

.drayage-buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;

  &__container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
.container-info {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-size: clamp(0.6rem, 2vw, 0.7rem);
  line-height: normal;
  &__label {
    margin: auto;
    width: 50%;
    max-width: 95px;
    font-size: 12px;
    word-break: break-word;
    p {
      margin: 0px;
    }
  }
  &__prices {
    width: 50%;
    display: flex;
    flex-direction: column;
    max-width: 95px;
    text-align: center;
    word-break: break-all;
    letter-spacing: 0.5px;
    span {
      margin: auto 0;
      font-size: 12px;
    }
    p {
      font-weight: bold;
    }
    label {
      font-size: 10px;
    }
  }
}
.quote-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 200px;
  min-width: 170px;
  margin: 4px;
  padding: 5px;
  height: 43px;
  border-radius: 15px;
  border: none;
  @include font-small-button-text;
  font-weight: bold;
  &--green {
    background: $color-carrier-quote-insurance-button;
    color: $color-carrier-quote-insurance-button-text;
  }
  &--blue {
    background: $color-carrier-quote-button;
    color: $color-white;
  }
  &.disabled-button {
    background: $color-disabled-button;
    color: $color-white;
  }
}

.list-detail {
  margin: 15px;
}

.detail-table {
  width: 100%;
  word-break: keep-all;
  white-space: normal;
  th {
    font-weight: bold;
    color: black;
  }
  tr{
    background-color: transparent;
  }
  td {
    padding: 5px;
    text-align: left;
    font-size: 14px;
    vertical-align: middle;
  }
}

.total-price-item {

  font-weight: bold;
  color: black;
}

.details-prices{
  display: flex;
  text-align: start;
  word-break: keep-all;
  white-space: normal;
}
.disclaimer-info {
  display: flex;
  text-align: left;
  align-items: flex-start;
  width: 100%;
  color: black;
  font-size: 12px;
  padding: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: keep-all;
  display: flex;
  flex-direction: column;
  &__text{
    display: flex;
    flex-direction: row;
    margin-bottom:5px;
    color: $color-primary-company;
    font-weight: 600;
  }
}
.disclaimer-icon {
  font-weight: bold;
  margin-right: 5px;
  color: $color-secondary-button-border;
}

@media (max-width: 800px) {
  .list-detail {
    width: auto;
  }
}

@media (max-width: 1200px) {
  .drayage-buttons {
     display: flex;
     flex-direction: column;
    &__container {
      display: flex;
      justify-content: space-evenly;
      flex-wrap: wrap;
    }
  }

  .total-price-item {
    border-top: 1px solid gainsboro;
  }

}

@media (min-width: 1200px) {
  .detail-table {
    border-right: 1px solid gainsboro;vertical-align: middle;
  }
}

.icons-tools {
  width: 12px;
  height: 12px;
  margin-right: 5px;
  cursor: pointer;
}
.section-container-text {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 10px;
  height: 100%;
  font-size: 13px;
  align-items: start;
  justify-content: center;
  color: black;
}
</style>
